import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class ImsAuditChecklistRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            number: props.number,
            header: props.header,
            auditFinding: props.auditFinding,
            auditFindingName: props.auditFindingName,
            evidenceViewed: props.evidenceViewed,
            evidenceViewedName: props.evidenceViewedName,
            iso9001: props.iso9001 ? props.iso9001.split('\n').map((item, i) => {
                return <p key={i}>{item}</p>;
            }) : "",
            iso14001: props.iso14001 ? props.iso14001.split('\n').map((item, i) => {
                return <p key={i}>{item}</p>;
            }) : "",
            iso45001: props.iso45001 ? props.iso45001.split('\n').map((item, i) => {
                return <p key={i}>{item}</p>;
            }) : "",
            qualityRequirement: props.qualityRequirement ? props.qualityRequirement.split('\n').map((item, i) => {
                return <p key={i}>{item}</p>;
            }) : "",
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        this.setState({
            ...this.state, [event.target.name]: event.target.value, [event.target.id]: event.target.value,
        });
        this.props.onChangeHandler();
    }

    render() {
        let {state} = this;

        return <React.Fragment>
            {state.header &&
            <TableRow>
                <TableCell align="center" style={{ backgroundColor: 'yellow'}}/>
                <TableCell align="left" colSpan={6} style={{ backgroundColor: 'blue'}}>
                    <Typography component="h7" variant="subtitle1" style={{ padding: "10px", paddingLeft: "20px", color: "white" }}>
                        {state.header}
                    </Typography>
                </TableCell>
            </TableRow>}
            <TableRow>
                <TableCell align="center" style={{ backgroundColor: 'yellow'}}>
                    {state.number}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${state.iso9001 && state.iso9001 !== "" ? "white" : "lightgrey"}` }}>
                    {state.iso9001}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${state.iso14001 && state.iso14001 !== "" ? "white" : "lightgrey"}` }}>
                    {state.iso14001}
                </TableCell>
                <TableCell align="center" style={{ backgroundColor: `${state.iso45001 && state.iso45001 !== "" ? "white" : "lightgrey"}` }}>
                    {state.iso45001}
                </TableCell>
                <TableCell align="left" style={{ backgroundColor: `${state.qualityRequirement && state.qualityRequirement !== "" ? "white" : "lightgrey"}` }}>
                    {state.qualityRequirement}
                </TableCell>
                <TableCell align="left">
                    <TextField
                        id={state.evidenceViewedName}
                        name="evidenceViewed"
                        value={state.evidenceViewed}
                        label="Evidence viewed during the audit"
                        multiline
                        rows={3}
                        onChange={this.onChange}
                        style={{ width: "100%" }}
                    />
                </TableCell>
                <TableCell align="left">
                    <TextField
                        id={state.auditFindingName}
                        name="auditFinding"
                        value={state.auditFinding}
                        label="Audit finding"
                        multiline
                        rows={3}
                        onChange={this.onChange}
                        style={{ display: "none" }}
                    />
                    <FormControl className={classes.formControl} style={{ width: '100%'}}>
                        <InputLabel id={`${state.auditFindingName} + '-labelId'`}>Audit finding</InputLabel>
                        <Select
                            labelId={`${state.auditFindingName} + '-labelId'`}
                            id={state.auditFindingName}
                            value={state.auditFinding}
                            name="auditFinding"
                            onChange={this.onChange}
                        >
                            <MenuItem value="Conformance (C)">Conformance (C)</MenuItem>
                            <MenuItem value="Nonconformance (NC)">Nonconformance (NC)</MenuItem>
                            <MenuItem value="Observation (OBS)">Observation (OBS)</MenuItem>
                        </Select>
                    </FormControl>
                </TableCell>
            </TableRow>
        </React.Fragment>;
    }
}

ImsAuditChecklistRow.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(ImsAuditChecklistRow);
